import { render, staticRenderFns } from "./BaseDropdown.vue?vue&type=template&id=2a2c211f&scoped=true&"
import script from "./BaseDropdown.vue?vue&type=script&lang=js&"
export * from "./BaseDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BaseDropdown.vue?vue&type=style&index=0&id=2a2c211f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2c211f",
  null
  
)

export default component.exports